module.exports = "/desktop-app/assets/img/shopee.svg?c19a18748e3415b58fcef54f93f7a5b1";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/shopee.svg
// module id = m5iZ
// module chunks = 1